import React from "react";
import { Card } from "../../../components/ui/Card";
import { cn } from "../../../libs/utils";
import { useLocation, useNavigate } from "react-router-dom";

const severityStyle = {
  Critical: "bg-rose-50 text-rose-600",
  Medium: "bg-amber-50 text-amber-600",
  Low: "bg-slate-100 text-slate-600",
};

const AlertsPanel = ({ alerts = [], isLoading, error, onMarkAsRead, batches = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const unreadCount = alerts.filter((alert) => !alert.isRead).length;

  return (
  <Card className="flex h-full min-h-[420px] max-h-[740px] flex-col overflow-hidden">
    <div className="flex items-center justify-between bg-slate-50 px-5 py-3">
      <h3 className="text-lg font-semibold text-slate-800">Alerts</h3>
      <span className="rounded-full bg-rose-50 px-2 py-0.5 text-xs font-semibold text-rose-500">{unreadCount} unread</span>
    </div>
    {error && alerts.length > 0 && <p role="status" className="border-b border-amber-100 bg-amber-50 px-5 py-2 text-xs text-amber-700">Notifications are reconnecting. Showing the latest received alerts.</p>}
    <div className="flex-1 overflow-y-auto">
      {isLoading ? (
        <p className="p-6 text-center text-sm text-slate-400" role="status">
          Loading alerts…
        </p>
      ) : alerts.length === 0 ? (
        <p className="p-6 text-center text-sm text-slate-400">{error ? "Unable to connect to notifications." : "No notifications yet."}</p>
      ) : (
        alerts.map((alert) => {
          const batch = batches.find((item) => item.batchId === alert.batchId);
          return (
          <div
            key={alert.id}
            className={cn(
              "block w-full border-b border-slate-100 px-5 py-3.5 text-left transition-colors last:border-0 hover:bg-slate-50",
              !alert.isRead && "border-l-2 border-l-brand bg-violet-50/60"
            )}
          >
            <div className="mb-1 flex items-center justify-between gap-2">
              <p className={cn("flex items-center gap-2 text-sm text-slate-700", !alert.isRead && "font-semibold text-slate-900")}>
                {!alert.isRead && <span className="h-2 w-2 rounded-full bg-brand" aria-label="Unread" />}
                {batch?.uid ? <button type="button" className="text-left hover:text-brand hover:underline" onClick={() => { onMarkAsRead?.(alert.id); navigate(`/setting/batch/${encodeURIComponent(batch.uid)}${location.search}`, { state: { from: `${location.pathname}${location.search}` } }); }}>Batch {alert.batchId}</button> : `Batch ${alert.batchId}`}
              </p>
              <span className={cn("rounded-full px-2 py-0.5 text-[10px] font-semibold", severityStyle[alert.severity])}>
                {alert.severity}
              </span>
            </div>
            <p className={cn("text-xs text-slate-500", !alert.isRead && "text-slate-700")}>
              {alert.cycleId && <span className="font-semibold text-slate-700">{alert.cycleId} </span>}{alert.message}
            </p>
            <p className="mt-1 text-[11px] text-slate-400">{alert.time}</p>
            {!alert.isRead && <button type="button" onClick={() => onMarkAsRead?.(alert.id)} className="mt-2 text-xs font-medium text-brand hover:underline">Mark as read</button>}
          </div>
        ); })
      )}
    </div>
  </Card>
  );
};

export default AlertsPanel;
